import { atomFamily } from 'recoil';

export const filteredListAtomFamily = atomFamily<
  { name: string; checked: boolean }[],
  string
>({
  key: 'filteredListAtomFamily',
  default: [],
});
